import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ConsumerMoneyOrderHandlerProvider } from '../../providers/consumer-money-order-handler';
import { BaseListPage } from '../../providers/base-list-page';

import { ConsumerMoneyOrderDetailPage } from '../../pages/consumer-money-order-detail/consumer-money-order-detail';

@Component({
  selector: 'page-consumer-money-main-order-list',
  templateUrl: 'consumer-money-main-order-list.html',
})
export class ConsumerMoneyMainOrderListPage extends BaseListPage {

	constructor(
		public navCtrl: NavController, 
		public mainService: ConsumerMoneyOrderHandlerProvider, 	
	) {
		super();
	}

	ionViewDidLoad() {
		this.isLoading = true;

		this.loadingMsg = "Loading..."

		this.load(()=>{
			this.isLoading = false;
		});	
	}		

	gotoDetail(order){
		this.mainService.order = order;

		this.navCtrl.push(ConsumerMoneyOrderDetailPage, {});		
	}	


	doRefresh(refresher) {
		this.isRefreshing = true;
		this.params.page = 1;
	
		this.load(()=>{
			this.isRefreshing  = false;

		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isFetchingMore = true;
		this.params.page++;

		this.load(()=>{
			infiniteScroll.complete();
		});
	}		

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.params.cbAfter = cb;

		this.mainService.getOrdersForAllBusinesses(this.params);
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-money-main-order-list/consumer-money-main-order-list.ts